import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {bankInfoMap: Object}

  static targets = ["field", "errorMessage", "bankname"]

  connect() {}

  validate() {
    this.fieldTarget.value = this.fieldTarget.value.replace(/\s+/g, '').toUpperCase();
    const iban = this.fieldTarget.value
    const input = this.fieldTarget.value;
    if (input == null || input == "" || input === false) {
      this.fieldTarget.classList.add('is-danger');
      this.errorMessageTarget.textContent = "Bitte eingeben";
      this.banknameTarget.value = "";
      return false;
    }

    if (!this.validGermanIBAN(iban)) {
      this.fieldTarget.classList.add('is-danger');
      this.errorMessageTarget.textContent = "Bitte gültige deutsche IBAN eingeben.";
      this.banknameTarget.value = "";
      return false;
    }
    this.fieldTarget.classList.remove('is-danger');
    this.errorMessageTarget.textContent = ""; // Clear error message
    this.banknameTarget.value = this.lookupBankName(iban);
    return true;
  }

  lookupBankName(iban) {
    return this.bankInfoMapValue[iban.slice(4, 12)];
  }

  blur() {
    this.element.removeEventListener('input', this.validate);
    const result = this.validate();
    this.element.addEventListener('input', () => {
      this.validate();
    });
    return result;
  }

  validGermanIBAN(iban) {
    if (iban == '') {
      return false;
    }
    if (!/^DE\d{20}$/.test(iban)) {
      return false;
    }
    let rearranged = iban.slice(4) + iban.slice(0, 4);
    let numericIban = rearranged.replace(/[A-Z]/g, letter => letter.charCodeAt(0) - 55);
    let remainder = numericIban.match(/\d{1,9}/g).reduce((acc, part) => (BigInt(acc + part) % 97n).toString(), '0');
    return remainder === '1';
  }
}
